<template>
    <div class="loading-mask">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">服务请求管理</el-breadcrumb-item>
                <el-breadcrumb-item>请求列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div v-if="back" class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div class="column-layout clearfix">
            <div v-cloak class="left-column fl" :class="{'show-current' : back , 'active' : !treeCollapse}">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">组织机构</li>
                        </ul>
                    </div>
                </div>
                <div id="tree-menu" style="overflow-y: auto;">
                    <swb-org-tree :searchSize="'mini'" :showIncludeSubComs="true" :enableSearch="true" @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
                </div>
            </div>
            <div v-loading="loading" class="right-column fl">
                <div>
                    <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
                    <!--<swb-servc-req-voucher-search ref="query_model" @showSearch="searchMethod"></swb-servc-req-voucher-search>-->
                </div>
                <div style="background-color: #fafafa;line-height: 49px;height: 49px;" v-if="!back">
                    <span class="ml15">当前公司：<span v-if="comInfo.id != null">{{comInfo.name}}</span><span v-else>无</span></span>
                </div>
                <div class="mt10 mb10">
                    <span class="mr20" v-if="deviceId != null &&servcReqVoucherList.length > 0">设备名称：{{servcReqVoucherList[0].goodsTitle}}</span>
                    <span v-if="svcSubNo != null">服务子号：{{svcSubNo}}</span>
                    <span v-if="tmpNo != null">系统编号：{{tmpNo}}</span>
                </div>
                <div class="table-layout">
                    <el-table :data="servcReqVoucherList" border>
                        <el-table-column prop="buyerShopName" width="150" label="请求机构" class="align-left"></el-table-column>
                        <el-table-column prop="requestTime" width="150" label="请求时间" class="align-left"></el-table-column>
                        <el-table-column prop="buyerContactName" width="80" label="机构联系人" class="align-left"></el-table-column>
                        <el-table-column prop="buyerContactTel" width="100" label="机构联系电话" class="align-left"></el-table-column>
                        <el-table-column prop="creatorName" width="100" label="请求人" class="align-left"></el-table-column>
                        <el-table-column label="设备名称" prop="goodsTitle" width="150" show-overflow-tooltip class="align-left"></el-table-column>
                        <el-table-column label="系统编号" width="250" show-overflow-tooltip class="align-left">
                            <template slot-scope="rows">
                                <span><a class="swb-btn-link" @click.stop="gotoShopDeviceSvcSubNo(rows.row.tmpNo)">{{rows.row.tmpNo}}</a></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="所属套装" prop="suitName" width="100" show-overflow-tooltip class="align-left"></el-table-column>
                        <el-table-column label="分类名称" prop="goodsCatName" width="150" show-overflow-tooltip class="align-left"></el-table-column>
                        <el-table-column label="服务名称" prop="title" width="150" show-overflow-tooltip class="align-left"></el-table-column>
                        <el-table-column label="服务号" prop="svcNo" width="150" class="align-left"></el-table-column>
                        <el-table-column label="服务子号" min-width="160" class="align-left">
                            <template slot-scope="rows">
                                <span>{{rows.row.svcSubNo}}</span>
                                <i v-if="rows.row.beyondWrnt && rows.row.svcSubNo != null" class="swb-icon table-wrnt"></i>
                                <i v-else-if="!rows.row.beyondWrnt && rows.row.svcSubNo != null" class="swb-icon table-unWrnt"></i>
                            </template>
                        </el-table-column>
                        <el-table-column label="请求单号" prop="no" min-width="160" class="align-left "></el-table-column>
                        <el-table-column label="是否保养" min-width="80" class="align-left ">
                            <template slot-scope="rows">
                                <el-tag v-if="rows.row.maintFlag" type="danger">保养</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" prop="state" width="80" class="align-left"></el-table-column>
                        <el-table-column label="服务商家" prop="dstSevicerName" width="150" show-overflow-tooltip class="align-left"></el-table-column>
                        <!--<el-table-column label="服务商联系方式" prop="servicerComContactTel" width="120" show-overflow-tooltip class="align-left"></el-table-column>-->
                        <el-table-column label="服务网点" prop="servicerComName" width="150" show-overflow-tooltip class="align-left"></el-table-column>
                        <el-table-column label="网点联系人" prop="dstContactName" width="80" class="align-left"></el-table-column>
                        <el-table-column label="网点联系电话" prop="dstContactTel" width="100" class="align-left"></el-table-column>
                        <el-table-column label="操作" fixed="right" align="left" width="100">
                            <template slot-scope="rows">
                                <a v-if="rows.row.tmpNo != null" class="swb-btn swb-btn-link" @click="showDeviceRepairRec(rows.row.tmpNo)">维保记录</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="block pagination-layout">
                    <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openDeviceRepairRecDlg } from '../workVoucher/showDetailDlg'

    import servcDisptApi from '../../api/servcDispt'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    import shopDevcApi from '../../api/shopDevc'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbShopDeviceList from '../devc/ShopDeviceList'
    Routes.add(SwbShopDeviceList);

    import SwbShopDeviceMaintainStatisList from '../statisWork/ShopDeviceMaintainStatisList.vue'
    Routes.add(SwbShopDeviceMaintainStatisList);

    import SwbDeviceMaintPlanList from './DeviceMaintPlanList.vue'
    Routes.add(SwbDeviceMaintPlanList);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "请求机构",
                "code": "buyerShopName",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "设备名称",
                "code": "goodsTitle",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "分类名称",
                "code": "goodsCatName",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "服务名称",
                "code": "title",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "服务商家",
                "code": "dstSevicerName",
                "basic": true,
            },
            {
                "type": "Text",
                "label": "服务网点",
                "code": "servicerComName",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "机构联系人",
                "code": "buyerContactName",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "请求人",
                "code": "creatorName",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Select",
                "label": "是否保养",
                "code": "maintFlag",
                "valueType": "Boolean",
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "服务子号",
                "code": "svcSubNo",
                "basic": false
            },
            {
                "type": "Text",
                "label": "服务号",
                "code": "svcNo",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "系统编号",
                "code": "tmpNo",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "请求单号",
                "code": "no",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Select",
                "valueType": "String",
                "label": "所属套装",
                "code": "suitName",
                "dataList": [
                    {
                        "value": null,
                        "label": "--全部--"
                    }
                ],
                "basic": false
            },
            {
                "type": "Text",
                "label": "网点联系人",
                "code": "dstContactName",
                "basic": false,
                "valueType": "String"
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "请求时间",
                "code": "requestTime"
            }
        ],
        "sortFields": [
            {
                "label": "请求时间",
                "code": "requestTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "请求机构",
                "code": "buyerShopName",
                "order": "desc",
                "enabled": false
            },
            {
                "label": "分类名称",
                "code": "goodsCatName",
                "order": "desc",
                "enabled": false
            },
            {
                "label": "服务商家",
                "code": "dstSevicerName",
                "order": "desc",
                "enabled": false
            },
            {
                "label": "服务网点",
                "code": "servicerComName",
                "order": "desc",
                "enabled": false
            }
        ]
    };

    export default {
        name: 'swb-servc-req-voucher-list',
        path: '/shop/device/req/info/list',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '服务请求单列表',
        props: {
            filter: {},
        },
        data: function () {
            return {
                treeCollapse: true,
                servcReqVoucherList: [],
                //跳转用
                no: null,
                svcSubNo: null,
                tmpNo: null,
                deviceId: null,
                back: false,
                backUrl: null,

                //
                thisComId: null,
                thisComLevel: null,
                shopFlag: false,
                includeSubComs: false,
                comInfo: {},
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                userContext: {
                    scopeEntity: {}
                },
                loading: false,

                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.deviceId = this.$route.query.deviceId || null;
            this.svcSubNo = this.$route.query.svcSubNo || null;
            this.tmpNo = this.$route.query.tmpNo || null;
            this.backUrl = this.$route.query.backUrl || null;
            this.no = this.$route.query.no || null;
            this.back = this.$route.query.back || false;
            // 从设备状态列表中跳转过来的标识
            this.gotoReqVoucher = this.$route.query.gotoReqVoucher || false;
            //
            this.queryConfig = searchConfigData || {};
            //
            this.getUserInfoByContext();
            this.getComDetail();
            if(this.back) {
                this.getServcReqVoucherDocList();
            }
            // 获取设备分组过滤条件
            this.getSuitNameList();
        },
        methods: {
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(tmpNo);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.getServcReqVoucherDocList();
            },
            //
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.shopFlag = eventData.shopFlag;
                    this.includeSubComs = eventData.includeSubComs;
                    this.getComDetail();
                    this.getServcReqVoucherDocList();
                }
            },
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userContext = result.data;
                        //self.comName = self.userContext.scopeEntity.comName;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                retailerApi.getRetailerCom(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.comInfo = Utils.merge({}, data);
                        self.thisComLevel = data.level;
                        self.thisComId = data.id;
                        self.getServcReqVoucherDocList();
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },

            searchMethod: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.getServcReqVoucherDocList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcReqVoucherDocList();
            },
            getServcReqVoucherDocList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                if(!Utils.isNoB(self.svcSubNo)) {
                    filterItems.svcSubNo = self.svcSubNo;
                }
                if(!Utils.isNoB(self.tmpNo)) {
                    filterItems.tmpNo = self.tmpNo;
                }
                if(!Utils.isNoB(self.deviceId)) {
                    filterItems.deviceId = self.deviceId;
                }
                if(!self.gotoReqVoucher) {
                    filterItems.buyerShopId = this.thisComId;
                    filterItems.comLevel = this.thisComLevel;
                    filterItems.includeSubComs = this.includeSubComs;
                }
                filterItems.gotoReqVoucher = this.gotoReqVoucher;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;

                let loading = MsgBox.loading();
                servcDisptApi.getServcReqVoucherDocList(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let servcReqVoucherList = result.data.rows;
                        self.servcReqVoucherList = servcReqVoucherList;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getSuitNameList: function () {  // 获取设备分组名称，去重
                let self = this;
                // 重置suitName 过滤条件
                self.queryConfig = {};
                //
                let theLoad = MsgBox.loading();
                shopDevcApi.getSuitNameList({}, function (result) {
                    if(result.type === "info") {
                        let suitNameList = result.data;
                        let querySuitNames = [];
                        if(!Utils.isNoB(suitNameList)) {
                            suitNameList.forEach(function (suitName) {
                                let querySuitName = {};
                                querySuitName.value = suitName;
                                querySuitName.label = suitName;
                                querySuitNames.push(querySuitName);
                            });
                        }
                        //
                        let queryConfig = searchConfigData || {};
                        let queryConfigMap = queryConfig.queryFields.toMap("code");
                        let suitNameItem = queryConfigMap['suitName'];
                        suitNameItem.dataList = [];
                        suitNameItem.dataList = Utils.merge([], querySuitNames);
                        //
                        self.queryConfig = queryConfig; //Utils.merge({}, );
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
            goBack: function () {
                if(this.backUrl == "svcSubNo") {
                    this.$router.push({
                        query: {},
                        path: SwbShopDeviceList.path,

                    });
                } else if(this.backUrl == "maintPlan") {
                    this.$router.push({
                        query: {},
                        path: SwbDeviceMaintPlanList.path,

                    });
                } else if(this.backUrl == "maintain") {
                    this.$router.push({
                        query: {},
                        path: SwbShopDeviceMaintainStatisList.path,

                    });
                }
            },
            gotoShopDeviceSvcSubNo: function (tmpNo) {
                let self = this;
                self.$router.push({
                    path: SwbShopDeviceList.path,
                    query: {
                        tmpNo: tmpNo,
                    }
                })
            },
            //组织树收缩
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMalfunctionStatisList.vue